import { render, staticRenderFns } from "./LogoSmall.vue?vue&type=template&id=0d95ee41"
import script from "./LogoSmall.vue?vue&type=script&lang=js"
export * from "./LogoSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d95ee41')) {
      api.createRecord('0d95ee41', component.options)
    } else {
      api.reload('0d95ee41', component.options)
    }
    module.hot.accept("./LogoSmall.vue?vue&type=template&id=0d95ee41", function () {
      api.rerender('0d95ee41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/LogoSmall.vue"
export default component.exports